import { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useRouter } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import { useRequireAuth } from '../../hooks/useRequireAuth';
import { createPostSheetVisibleAtom } from '../../atoms';

// This screen is a placeholder - the create tab opens a bottom sheet instead
// If user somehow navigates here directly, redirect back and open the sheet
export default function CreateScreen() {
  const router = useRouter();
  const { colors } = useTheme();
  const { user } = useAuth();
  const { requireAuth } = useRequireAuth();
  const setCreatePostSheetVisible = useSetAtom(createPostSheetVisibleAtom);

  useEffect(() => {
    // Check authentication before opening the sheet
    if (!requireAuth()) {
      router.back();
      return;
    }
    
    // Go back and open the sheet
    router.back();
    setCreatePostSheetVisible(true);
  }, []);

  return (
    <View style={[styles.container, { backgroundColor: colors.background }]} />
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});
